import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { Tabs, Tab, Row, Col, Button } from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import {connect} from 'react-redux'
import {Switch,Route,withRouter} from 'react-router-dom'
import FormJsonSchema from "react-jsonschema-form";
import { DEFAULT_SCHEMA, DEFAULT_UI_SCHEMA } from './EmployeeEditGenFormSchema'
import ReportEmployeeAbsence from '../report/ReportEmployeeAbsence'
import EmployeeWorkMonthlyReport from '../EmployeeWorkMonthlyReport'
import WorkDocAttachmentDoc from '../../workdoc/WorkDocAttachmentDoc'
class EmployeeEditPage extends Component {

    initialData = {
        group1: {},
        group2: {},
        group3: {},
        group4: {},
        group5: {},
        group6: {},
        group7: {}
    }

    constructor(props) {
        super(props)
      
        this.state = {
            activeKey:'em_tab1',
            loading:false,
            formData:this.initialData,
            schema:DEFAULT_SCHEMA,
            uiSchema:DEFAULT_UI_SCHEMA,
            fields:{}
        }
    }

    componentDidMount() {
        this.setTab()
    }
    
    setTab() {
        let {location} = this.props
        if (location.pathname==='/em_tab2')
            this.onTabsSelect('em_tab2')
        else if (location.pathname==='/em_tab3')
            this.onTabsSelect('em_tab3')
        else if (location.pathname==='/em_tab4')
            this.onTabsSelect('em_tab4')
        else if (location.pathname==='/em_tab5')
            this.onTabsSelect('em_tab5')
        else if (location.pathname==='/em_tab6')
            this.onTabsSelect('em_tab6')
        else
            this.onTabsSelect('em_tab1')
    }

    onTabsSelect(key) {
        let pathname = '/'+key
        this.setState({activeKey:key})
        this.props.history.push({pathname:pathname,search:'',state:{}})
    }

    onFormChange(type,e) {
        // let {formData} = e
        // let newFormData = {
        //     ...formData
        // };   
    
        // let new_state = {
        //     formData: newFormData,
        // };
        // this.setState(new_state)

        let {formData} = e
        let newFormData = {
            ...this.state.formData,
            [type]: {
                ...this.state.formData[type],
                ...formData,
            },
        };   
    
        let new_state = {
            formContext: {
                ...this.state.formContext,
                formData: newFormData,
            },
            formData: newFormData,
        };
        this.setState(new_state)
    }

    renderEmpProfile() {
        return(
            <div>
                <div>
                    <Box>
                        <Box.Body>
                            <img className="profile-user-img img-responsive img-circle" alt="User profile picture" src="//api.bigfix.co/demo2/employee/photo_profile?em=KKC1030&amp;t=1566529135844" />
                            <h3 className="em-name text-center">นาย นิพนธ์ สีสุพะ</h3>
                            <p className="text-muted text-center em-edit-position"></p>
                            <ul className="list-group list-group-unbordered">
                                <li className="list-group-item">
                                    <b>รหัสพนักงาน</b> <a className="pull-right">KKC1030</a>
                                </li>
                                <li className="list-group-item">
                                    <b>รหัสในระบบ(ออฟฟิศ)</b> <a className="pull-right">po@demo2</a>
                                </li>
                                <li className="list-group-item">
                                    <b>วัน เดือน ปี เกิด</b> <a className="pull-right">26/05/2526 (36 ปี)</a>
                                </li>
                                <li className="list-group-item">
                                    <b>ทำงานมาแล้ว</b> <a className="pull-right">2 ปี 10 เดือน</a>
                                </li>
                                <li className="list-group-item">
                                    <b>เงินเดือน(ล่าสุด)</b> <a className="pull-right">5,220 บาท</a>
                                </li>
                                <li className="list-group-item" style={{display:'inline-flex',width:'100%'}}>
                                    <div id="qrcode-button">
                                        <div data-reactroot="">
                                            <button type="button" className="btn btn-default">
                                                <span aria-hidden="true" className="fa fa-qrcode"></span> QRCode
                                            </button>    
                                        </div>
                                    </div>
                                    &nbsp;
                                    <div id="barcode-button">
                                        <div data-reactroot="">
                                            <button type="button" className="btn btn-default">
                                                <span aria-hidden="true" className="fa fa-barcode"></span> Barcode
                                            </button>
                                        </div>
                                    </div>
                                </li>                                               
                            </ul>
                        </Box.Body>
                    </Box>
                </div> 
                <div>
                    <Box>
                        <Box.Header border={true}>
                            <Box.Title>ข้อมูลการศึกษา</Box.Title>
                        </Box.Header>
                        <Box.Body>
                            <Row>
                                <Col md={12}>
                                    <strong><i className="fa fa-book margin-r-5"></i>  การศึกษา</strong>
                                    <div className="pull-right">
                                        <a role="menuitem" className="btn btn-box-tool" href="#">
                                            <strong><i className="fa fa-pencil margin-r-5 "></i></strong>
                                        </a>
                                    </div>
                                </Col>    
                            </Row>
                            <ul className="list-group list-group-unbordered"></ul>
                            <hr />
                            <Row>
                                <Col md={12}>
                                    <strong><i className="fa fa-map-marker margin-r-5"></i> ประวัติทำงาน</strong>
                                    <div className="pull-right">
                                        <a role="menuitem" className="btn btn-box-tool" href="#">
                                            <strong><i className="fa fa-pencil margin-r-5 "></i></strong>
                                        </a>
                                    </div>
                                </Col>    
                            </Row>
                            <ul className="list-group list-group-unbordered"></ul>
                        </Box.Body>
                    </Box>            
                </div>   
            </div>
        )
    }

    renderTab1() {
        let {schema,uiSchema,fields,formData} = this.state
        return(
            <div>
                <Box>
                    <Box.Body>
                        <Row>
                            <Col md={3}>{this.renderEmpProfile()}</Col>
                            <Col md={9}>
                                <div>
                                    <Box>
                                        <Box.Body>
                                            <FormJsonSchema
                                                schema={schema.group1}
                                                uiSchema={uiSchema.group1}
                                                fields={fields}
                                                formData={formData.group1}
                                                onChange={this.onFormChange.bind(this,'group1')}
                                            >
                                                <div></div>
                                            </FormJsonSchema>
                                        </Box.Body>
                                    </Box>  
                                </div>
                                <div>
                                    <Box>
                                        <Box.Body>
                                            <FormJsonSchema
                                                schema={schema.group2}
                                                uiSchema={uiSchema.group2}
                                                fields={fields}
                                                formData={formData.group2}
                                                onChange={this.onFormChange.bind(this,'group2')}
                                            >
                                                <div></div>
                                            </FormJsonSchema>
                                        </Box.Body>
                                    </Box>    
                                </div>
                                <div>
                                    <Box>
                                        <Box.Body>
                                            <FormJsonSchema
                                                schema={schema.group3}
                                                uiSchema={uiSchema.group3}
                                                fields={fields}
                                                formData={formData.group3}
                                                onChange={this.onFormChange.bind(this,'group3')}
                                            >
                                                <div></div>
                                            </FormJsonSchema>
                                        </Box.Body>
                                    </Box>    
                                </div>
                                <div>
                                    <Box>
                                        <Box.Header border={true}>
                                            <Box.Title><FontAwesome name='history' className='text-blue' /> สิทธิ์ในการลางาน (ทั้งปี)</Box.Title>
                                        </Box.Header>
                                        <Box.Body>
                                            <FormJsonSchema
                                                schema={schema.group4}
                                                uiSchema={uiSchema.group4}
                                                fields={fields}
                                                formData={formData.group4}
                                                onChange={this.onFormChange.bind(this,'group4')}
                                            >
                                                <div></div>
                                            </FormJsonSchema>
                                        </Box.Body>
                                    </Box>    
                                </div>     
                                <div>
                                    <Box>
                                        <Box.Header border={true}>
                                            <Box.Title><FontAwesome name='history' className='text-blue' /> สวัสดิการ</Box.Title>
                                        </Box.Header>
                                        <Box.Body>
                                            <FormJsonSchema
                                                schema={schema.group5}
                                                uiSchema={uiSchema.group5}
                                                fields={fields}
                                                formData={formData.group5}
                                                onChange={this.onFormChange.bind(this,'group5')}
                                            >
                                                <div></div>
                                            </FormJsonSchema>
                                        </Box.Body>
                                    </Box>    
                                </div>
                                <div>
                                    <Box>
                                        <Box.Header border={true}>
                                            <Box.Title><FontAwesome name='history' className='text-blue' /> แสดงชื่อพนักงานในระบบ</Box.Title>
                                        </Box.Header>
                                        <Box.Body>
                                            <FormJsonSchema
                                                schema={schema.group6}
                                                uiSchema={uiSchema.group6}
                                                fields={fields}
                                                formData={formData.group6}
                                                onChange={this.onFormChange.bind(this,'group6')}
                                            >
                                                <div></div>
                                            </FormJsonSchema>
                                        </Box.Body>
                                    </Box>    
                                </div>
                                <div>
                                    <Box>
                                        <Box.Header border={true}>
                                            <Box.Title><FontAwesome name='money' className='text-blue' /> ผู้ออกสลิปเงินเดือน</Box.Title>
                                        </Box.Header>
                                        <Box.Body>
                                            <FormJsonSchema
                                                schema={schema.group7}
                                                uiSchema={uiSchema.group7}
                                                fields={fields}
                                                formData={formData.group7}
                                                onChange={this.onFormChange.bind(this,'group7')}
                                            >
                                                <div></div>
                                            </FormJsonSchema>
                                        </Box.Body>
                                    </Box>    
                                </div>      
                            </Col>
                        </Row>
                    </Box.Body>    
                    <Box.Footer>
                        <div className='pull-right'>
                            <Button bsStyle='primary'><FontAwesome name='save' /> บันทึก</Button>
                        </div>
                    </Box.Footer>
                </Box>        
            </div>
        )
    }

    renderTab2() {
        return(
            <div>renderTab2</div>
        )
    }

    renderTab3() {
        return(
            <div>renderTab3</div>
        )
    }

    renderTab4() {
        return(
            <div>
                <ReportEmployeeAbsence

                />
            </div>
        )
    }

    renderTab5() {
        return(
            <div>
                <EmployeeWorkMonthlyReport
                    em='KKC0003'
                />
            </div>
        )
    }

    renderTab6() {
        return(
            <div>
                <WorkDocAttachmentDoc
                    workNo='SRY.0307/2562'
                />
            </div>
        )
    }

    render() {
        let {activeKey} = this.state
        let titleTab1 = (<span><FontAwesome name='car' /> ข้อมูลทั่วไป</span>)
        let titleTab2 = (<span><FontAwesome name='bank' /> เงินเดือนและสวัสดิการ</span>)
        let titleTab3 = (<span><FontAwesome name='user' /> เวลาทำงาน</span>)
        let titleTab4 = (<span><FontAwesome name='check-square-o' /> ลางาน</span>)
        let titleTab5 = (<span><FontAwesome name='dashboard' /> การทำงาน</span>)
        let titleTab6 = (<span><FontAwesome name='archive' /> ไฟล์เอกสาร</span>)
        return(
            <div>
                <Box loading={this.state.loading}>
                    <Box.Body>
                        <Tabs 
                            activeKey={activeKey}
                            id='employee-edit-tabs'
                            onSelect={this.onTabsSelect.bind(this)}
                        >
                            <Tab eventKey={'em_tab1'} title={titleTab1}></Tab>
                            <Tab eventKey={'em_tab2'} title={titleTab2}></Tab>
                            <Tab eventKey={'em_tab3'} title={titleTab3}></Tab>
                            <Tab eventKey={'em_tab4'} title={titleTab4}></Tab>
                            <Tab eventKey={'em_tab5'} title={titleTab5}></Tab>
                            <Tab eventKey={'em_tab6'} title={titleTab6}></Tab>
                        </Tabs>
                        <Switch>
                            <Route exact path="/em_tab1" render={(props) => this.renderTab1()}/>                            
                            <Route exact path="/em_tab2" render={(props) => this.renderTab2()}/>
                            <Route exact path="/em_tab3" render={(props) => this.renderTab3()}/>
                            <Route exact path="/em_tab4" render={(props) => this.renderTab4()}/>
                            <Route exact path="/em_tab5" render={(props) => this.renderTab5()}/>
                            <Route exact path="/em_tab6" render={(props) => this.renderTab6()}/>                            
                            <Route render={(props) => this.renderTab1()}/>                         
                        </Switch>
                    </Box.Body>    
                </Box>    
            </div>           
        )
    }
}

EmployeeEditPage.defaultProps = {
        
}

const _Connect = connect(
  (state) => ({messages: state.message.view.hr.employee.EmployeeEditPage}),null,null,{withRef:true}
)(EmployeeEditPage);

export default withRouter(_Connect)


// WEBPACK FOOTER //
// ./src/view/hr/employee/EmployeeEditPage.js